import "./styles/MenuBarItemLink.scss";
import React from "react";
import {MenuItem} from "navigation-common/types/navigation-types";
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';
import ChevronUpIcon from '@atlaskit/icon/glyph/chevron-up';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {fontAwesomeService} from "../api/FontAwesomeService";
import {AnalyticsEvents, postHogService} from "../api/PostHogService";
import HipchatChevronDownIcon from '@atlaskit/icon/glyph/hipchat/chevron-down'
import {IconButton} from '@atlaskit/button/new';
import ChevronRightLargeIcon from "@atlaskit/icon/glyph/chevron-right-large";
import {openCqlResultsDialog} from "./cql-modal/CqlModal";
import SearchIcon from '@atlaskit/icon/core/search';

interface MenuItemLinkComponentProps {
    menuItem: MenuItem,
    activated: boolean,
    onPress?: () => void,
    preview?: boolean,
    onToggleSubMenuClicked?: () => void,
    isSubMenuOpen?: boolean
}

const MenuBarItemLink = (props: MenuItemLinkComponentProps) => {
    const activateMenu = () => {
        if (props.onPress) {
            props.onPress();
        }
    }

    const onTogggleSubMenu = () => {
        if (props.onToggleSubMenuClicked) {
            props.onToggleSubMenuClicked();
        }
    }

    const logMenuClick = () => {
        if (props.preview) {
            return;
        }

        postHogService.logEvent(AnalyticsEvents.USER_NAVI_ITEM_LVL1_CLICKED);
    }

    const renderLinkedItem = (children?: React.ReactNode) => {
        return <div className={"button-text-container item-container"}><a href={props.preview ? undefined : props.menuItem.link}
                                                                          onClick={logMenuClick} onAuxClick={logMenuClick}
                                                                          target={props.menuItem.openInNewTab ? "_blank" : "_parent"}>
            <div className={`button clickable level-${props.menuItem.level}`}>
                {props.menuItem.icon && props.menuItem.icon.length > 0 && props.menuItem.level === 1 &&
                    <FontAwesomeIcon className={"menu-icon"} icon={fontAwesomeService.icon(props.menuItem.icon)} size={"lg"}/>
                }
                <span className={"button-text"}>{props.menuItem.name}</span>
            </div>
        </a>{children}</div>;
    }

    function renderSubMenuTrigger() {
        return <>
                <span className={"chevron lvl2Opener"} onClick={() => {
                    activateMenu();
                    logMenuClick();
                }}>
                    {props.activated ?
                        <ChevronUpIcon label={"close menu"}/> : <ChevronDownIcon label={"open menu"}/>
                    }
                </span>
        </>;
    }

    function renderTextItem() {
        return <div className={"item-container"}>
            <div className={`button level-${props.menuItem.level}`}>
                {props.menuItem.icon && props.menuItem.icon.length > 0 && props.menuItem.level === 1 &&
                    <FontAwesomeIcon className={"menu-icon"} icon={fontAwesomeService.icon(props.menuItem.icon)} size={"lg"}/>
                }
                <span className={"button-text"}>{props.menuItem.name}</span>
            </div>
            {props.menuItem.level === 1 && props.menuItem.subMenuItems && props.menuItem.subMenuItems.length > 0 && renderSubMenuTrigger()}</div>;
    }

    function renderCqlItem() {
        if(!props.menuItem.name || props.menuItem.name.trim() === "") {
            return null;
        }

        return <div className={"button-text-container item-container"}>
            <a
                onClick={() => openCqlResultsDialog(props.menuItem.name, props.menuItem.cqlString!, props.preview || props.menuItem.openInNewTab || false, props.menuItem.imageUrl || undefined)}
                onAuxClick={logMenuClick}>
                <div className={`button clickable level-${props.menuItem.level}`}>
                    {props.menuItem.icon && props.menuItem.icon.length > 0 && props.menuItem.level === 1 &&
                        <FontAwesomeIcon className={"menu-icon"} icon={fontAwesomeService.icon(props.menuItem.icon)} size={"lg"}/>
                    }
                    <span className={"button-text"}>{props.menuItem.name}</span>
                    <span className={"cqlIcon"}><SearchIcon label={"open results in an overlay"} spacing={"spacious"}/></span>
                </div>
            </a>
            {props.menuItem.level === 1 && props.menuItem.subMenuItems && props.menuItem.subMenuItems.length > 0 && renderSubMenuTrigger()}
        </div>;
    }

    const menuItemEntry = () => {
        if (props.menuItem.level === 1) {
            if (props.menuItem.link && props.menuItem.subMenuItems && props.menuItem.subMenuItems.length > 0) {
                return renderLinkedItem(renderSubMenuTrigger());
            } else if (props.menuItem.cqlEnabled && props.menuItem.cqlString) {
                return renderCqlItem();
            } else if (!props.menuItem.cqlEnabled && props.menuItem.link) {
                return renderLinkedItem();
            }
            return renderTextItem();
        }

        if (props.menuItem.cqlEnabled && props.menuItem.cqlString) {
            return renderCqlItem();
        }

        return props.menuItem.link ? renderLinkedItem() : renderTextItem();
    }

    return <>
        {props.menuItem.level !== 2 && menuItemEntry()}

        {props.menuItem.level === 2 &&
            <div className={"menuItemImageContainer"}>
                {props.menuItem.imageUrl && !props.menuItem.link &&
                    <div className={"teaser-image"} style={{backgroundImage: `url(${props.menuItem.imageUrl})`}}></div>
                }

                {props.menuItem.imageUrl && props.menuItem.link &&
                    <a href={props.preview ? undefined : props.menuItem.link} target={props.menuItem.openInNewTab ? "_blank" : "_parent"}>
                        <div className={"teaser-image"} style={{backgroundImage: `url(${props.menuItem.imageUrl})`}}></div>
                    </a>
                }

                {menuItemEntry()}

                {props?.menuItem?.subMenuItems && props?.menuItem?.subMenuItems?.length > 0 &&
                    <div className={"subMenuTrigger"}>
                        <IconButton onClick={onTogggleSubMenu} appearance={"subtle"} icon={props.isSubMenuOpen ? HipchatChevronDownIcon : ChevronRightLargeIcon}
                                    label="submenu-trigger"/>
                    </div>}
            </div>
        }
    </>
}

export default MenuBarItemLink;
